module.exports = __webpack_public_path__ + "static/media/trpl-logo.3a26e184.png";